import React, { useState } from 'react';
import { clearRedisKeyData } from '../../../services/api/clearRedisKey';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const inputButtonContainerStyle = {
  display: 'flex',
  alignItems: 'center',
};

const inputStyle = {
  padding: '10px 30px',
  border: '1px solid #ccc',
  borderRadius: '5px',
};

const buttonStyle = {
  backgroundColor: '#00baaa',
  color: '#fff',
  padding: '11px 10px',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer',
};

const headingStyle = {
  textAlign: 'center',
  fontSize: '24px',
  margin: '0 0 20px 0',
};

function RedisSingleClearComponent() {
  const [key, setKey] = useState('');
  const [message, setMessage] = useState('');

  const clearRedisKey = async () => {
    try {
      if (key.length === 0) {
        setMessage('')
        alert('Please Enter Key.');
      } else {
        const response = await clearRedisKeyData(key);
        setMessage(response.data);
        setKey('');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again!');
    }
  };

  return (
    <div className="container my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={containerStyle}>
        <div style={inputButtonContainerStyle}>
          <input type="text" value={key} onChange={(e) => setKey(e.target.value)} placeholder="Enter Redis Key" style={inputStyle} />
          <button className="mx-3" style={buttonStyle} onClick={clearRedisKey}>
            Clear Key
          </button>
        </div>
      </div>
      <div className='my-5'>{message}</div>
    </div>
  );
}
export default RedisSingleClearComponent;